<template>
  <div id="home">
    <p class="crtTextShadow">Welcome to</p>
    <div class="title crtTextShadow">
      <span class="fat">fawan.</span>
      <span>space</span>
    </div>
    <div id="about">
      <div>
        <img id="avatar" src="../assets/avatar.png" />
      </div>
      <div>
        <div class="crtTextShadow">
          <p>
            Hi,
            <br />
            <br />I am Fabian Raubart.
          </p>
          <p>I'm a web developer.</p>
        </div>
        <br />
        <div>
          I can do
          <br />
          <img class="skillIcon" src="../assets/HTML5.png" />
          <img class="skillIcon" src="../assets/logo.png" />
          <img class="skillIcon" src="../assets/C_Sharp.png" />
          <img class="skillIcon" src="../assets/sql.svg" />
          <img class="skillIcon" src="../assets/Python.png" />
        </div>
      </div>
    </div>
    <div id="sagansQuote">
      <p style="font-style: italic;">
        "Look again at that
        <a
          style="color: #4977a5;"
          href="https://en.wikipedia.org/wiki/Pale_Blue_Dot"
          target="_blank"
        >dot</a>. That's here. That's home. That's us."
      </p>

      <p>-Carl Sagan</p>
    </div>
    <div id="contact">
      <p>CONTACT ###</p>
      <div id="contactContainer">
        <div></div>
        <img src="../assets/svgs/github.svg" />
        <img src="../assets/svgs/mail.svg" />
        <div></div>
      </div>
    </div>
    <div id="underConstruction">
      <h2>### Under Construction ###</h2>
    </div>
  </div>
</template>
<script>
export default {
  name: "Home",
  components: {},
  methods: {},
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
#underConstruction {
  position: fixed;
  bottom: 0%;
}
#home {
  display: flex;
  flex-direction: column;
  padding-top: 200px;
}

.title {
  font-size: 48pt;
}

#sagansQuote {
  position: absolute;
  padding-top: 250px;
  top: 200vh;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14pt;
}

#about {
  position: absolute;
  top: 100vh;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  padding-top: 150px;
}
.skillIcon {
  height: 100px;
}

#avatar {
  /* height: 35vh; */
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  width: 25vw;
}

#contact {
  position: absolute;
  top: 300vh;
  padding-top: 250px;
  display: flex;
  flex-direction: column;
  width: 100%;
}
#contactContainer {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 200px;
  justify-content: space-around;
}
#contactContainer img {
  height: 100px;
}

@media only screen and (max-width: 640px) {
  #about {
    flex-direction: column;
  }
  #avatar {
    width: 35vw;
  }
}
@media only screen and (min-width: 641px) and (max-width: 800px) {
}
@media only screen and (min-width: 801px) and (max-width: 1024px) {
}
@media only screen and (min-width: 1025px) {
}
</style>